import React from "react"
import logo from "../images/casey_logo_trimmed.PNG"
import heroPhoto from "../images/hero_red_web.jpg"
import bioPhoto from "../images/bio_web.jpg"
import { Tour } from "../tour/Tour"
import { MusicSection } from "../musicPage/Music"
import { MerchGrid } from "../store/Store"
import { SectionHeader } from "../SectionHeader"
import { About } from "../About"
import { SOCIAL_LINKS, STREAMING_LINKS } from "../links"
import "./Home.css"

// released songs only — unreleased titles stay on the EPK
const SONGS = ["KTR", "This Misery", "These Horns", "Stuck In The Middle", "HoneyLocust"]

const spotify = STREAMING_LINKS.find(link => link.name === "Spotify")

const Hero = () => (
    <header className="lf-hero">
        <div className="lf-hero__photo" style={{ backgroundImage: `url(${heroPhoto})` }}></div>
        <div className="lf-hero__content">
            <div>
                <img className="lf-hero__logo" src={logo} alt="Lowfye50" />
                <div className="lf-hero__tag">HEAVY ROCK &nbsp;/&nbsp; NASHVILLE, TN</div>
            </div>
            <div className="lf-hero__cta">
                <div className="lf-hero__label">{"// STREAM EVERYWHERE"}</div>
                <a className="lf-btn lf-btn--primary" target="_blank" rel="noreferrer" href={spotify.href}>
                    <i className="fas fa-play"></i> Listen now
                </a>
                <div className="lf-hero__icons">
                    {[...STREAMING_LINKS, ...SOCIAL_LINKS].map(link => (
                        <a key={link.name} target="_blank" rel="noreferrer" href={link.href} aria-label={link.name} title={link.name}>
                            <i className={link.icon}></i>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    </header>
)

const SongMarquee = () => (
    <div className="lf-marquee" aria-hidden="true">
        <div className="lf-marquee__track">
            {/* two identical halves so the -50% scroll loops seamlessly, each long enough to fill wide screens */}
            {[...SONGS, ...SONGS, ...SONGS, ...SONGS].map((song, i) => (
                <span key={i}>{song}<i className="fas fa-times"></i></span>
            ))}
        </div>
    </div>
)

export const LandingPage = () => (
    <>
        <Hero />
        <SongMarquee />
        <MusicSection />
        <Tour homePage={true} />
        <About photo={bioPhoto} />
        <section className="lf-section" id="merch">
            <div className="lf-wrap">
                <SectionHeader eyebrow="Official store" title="Merch" />
                <MerchGrid />
            </div>
        </section>
    </>
)
